<!-- A div, not a <form>: @rappi/ui inputs inside a <form> require a FormGroup/ControlContainer. -->
<div class="lh-search" [class.lh-search--large]="size === 'large'" role="search">
  <one-input
    class="lh-search-input"
    type="search"
    name="lh-search"
    autocomplete="off"
    [label]="'learningHub.searchPlaceholder' | lhTranslate: lang"
    [formControl]="control"
    (keydown.enter)="submit($event)"
  ></one-input>
  <button
    type="button"
    class="lh-search-submit"
    [attr.aria-label]="'learningHub.searchSubmit' | lhTranslate: lang"
    (click)="submit()"
  >
    <span class="lh-search-arrow" aria-hidden="true">→</span>
  </button>
</div>
